module.exports = __webpack_public_path__ + "img/activity-time-notice.b260f34e.png";